<template>
  <div class="container">
    <span class="title">
      {{ title }}
    </span>
    <div class="chips">
      <div
        v-for="item in options"
        :key="item"
        :class="['item', { ['active-item']: value === item }]"
        @click="onChange(item)"
        @keydown="handleKeyDown($event, item)"
        role="button"
        tabindex="0"
      >
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChipsSelector",
  components: {},
  props: {
    title: String,
    value: [String, Number],
    onChange: Function,
    options: {
      type: Array,
      required: true,
    },
  },
  methods: {
    handleKeyDown(e, item) {
      if (e.key === "Enter" || e.key === " ") {
        this.onChange(item);
      }
    },
  },
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.chips {
  display: flex;
  gap: 8px;
}

.title {
  color: #000025;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px; /* 133.333% */
  letter-spacing: 2px;
  text-transform: uppercase;
  opacity: 0.5;
}

.item {
  cursor: pointer;
  box-sizing: border-box;
  display: flex;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
  border-radius: 32px;
  border: 2px solid #0000250d;
  color: #000025;
  font-family: "sofia-pro", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px;
}

.active-item {
  background-color: #0000250d;
  border: 2px solid rgba(0, 0, 0, 0);
}
</style>
